import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable, of } from 'rxjs';
import { FormFieldAbstractComponent } from '../abstract.component';
import { provideTranslation } from '@skyeng/libs/shared/i18n';
import { FormFieldsService } from '@shared/shared';
import { DateAdapter } from '@angular/material/core';
import startOfDay from 'date-fns/startOfDay';
import isSameDay from 'date-fns/isSameDay';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'crm-form-field-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideTranslation('formFieldDate', () => import.meta.webpackContext!('./translation'))],
})
export class FormFieldDateComponent extends FormFieldAbstractComponent {
  private readonly lang = this.transloco.getActiveLang() || this.transloco.getDefaultLang();

  get readonlyValue$(): Observable<any> {
    return of(this.getFormControl().value);
  }

  constructor(
    protected formFieldsService: FormFieldsService,
    private transloco: TranslocoService,
    private adapter: DateAdapter<Date>,
  ) {
    super(formFieldsService);
    this.adapter.setLocale(this.lang);
  }

  minMaxFilter = (value: Date | null): boolean => {
    const date = startOfDay(value || new Date());
    const minDate = this.formFieldsService.getValidatorConstraint(this.field, 'min');
    const maxDate = this.formFieldsService.getValidatorConstraint(this.field, 'max');

    let result = true;
    if (minDate) {
      result = date >= startOfDay(minDate);
    }

    if (maxDate) {
      result = result && date <= startOfDay(maxDate);
    }

    return result || isSameDay(this.getFormControl().value, date);
  };
}
